import { cn } from "@/lib/utils";
import { BLANK_TEXT_PLACEHOLDER, formatTextEntryValue } from "../../entryValueDisplay";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface LongTextEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function LongTextEntryValue({ value, inputLabel, size, className, ...props }: LongTextEntryValueProps) {
    const displayValue = formatTextEntryValue(value);
    const isBlank = displayValue === BLANK_TEXT_PLACEHOLDER;

    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <p
                className={cn(
                    size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-md",
                    isBlank ? "text-muted-foreground italic" : "text-slate-900 dark:text-slate-200"
                )}
            >
                {displayValue}
            </p>
        </BaseEntryValue>
    );
}
